/**
 * Cheap, synchronous "could this browser be signed in?" check.
 *
 * Used only to skip downloading signed-in pages for visitors who certainly
 * have no session. It never grants access: the page still verifies the real
 * session. Returns true (assume signed in) whenever unsure, e.g. during an
 * OAuth return, so a valid sign-in is never bounced.
 */
export function mightHaveSession(): boolean {
  if (typeof window === "undefined") return true;
  try {
    const { search, hash } = window.location;
    if (/[?&#](code|access_token|refresh_token|error_description)=/.test(search + hash)) return true;
    const ls = window.localStorage;
    for (let i = 0; i < ls.length; i += 1) {
      const key = ls.key(i);
      if (key && /^sb-.*-auth-token$/i.test(key) && ls.getItem(key)) return true;
    }
    return false;
  } catch {
    return true;
  }
}
